import { HttpClient,  HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "./app-config.service";
import { Observable } from "rxjs/internal/Observable";

@Injectable({
    providedIn: 'root'
})
export class ExportReviewService {
    httpOptions: any = { responseType: 'Blob' };
    apiUrl = AppConfig.settings.apiUrl;
    constructor(private httpClient: HttpClient) {
    }


  getExportReviewByCrId(crIds: number[]): Observable<HttpResponse<Blob>> {
    return this.httpClient.post(`${this.apiUrl}ExportReview/ExportReview`, crIds, {
      observe: 'response',    
      responseType: 'blob'   
    });
  }
}
